import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { api } from "../lib/api";
import { ArrowLeft } from "lucide-react";

export default function InsightDetail() {
  const { slug } = useParams();
  const { lang, t } = useI18n();
  const [post, setPost] = useState(null);

  useEffect(() => {
    api.get(`/posts/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(false));
  }, [slug]);

  if (post === false) return <div className="p-20 text-center">Not found</div>;
  if (!post) return <div className="p-20 text-center text-slate-500">Loading…</div>;

  const title = lang === "ar" ? post.title_ar : post.title_en;
  const body = lang === "ar" ? post.body_ar : post.body_en;

  return (
    <article data-testid="insight-detail-page" className="max-w-3xl mx-auto px-6 lg:px-10 py-24">
      <Link to="/insights" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 mb-10">
        <ArrowLeft className="w-4 h-4 rtl:rotate-180" /> {t.nav.insights}
      </Link>
      <p className="eyebrow">
        {post.category} · {post.read_minutes} {t.blog.minutes}
      </p>
      <h1 className="font-display text-4xl lg:text-6xl mt-4 leading-[1.0] tracking-tight">{title}</h1>
      <p className="mt-6 text-sm text-slate-500">{post.author} · {post.published_at}</p>
      <div className="mt-12 text-lg text-slate-700 leading-[1.8] whitespace-pre-line">
        {body}
      </div>
    </article>
  );
}
